import { hideDialog } from "fe2/Actions/ActionDialog";
import { acceptInvite } from "fe2/Actions/ActionInvites";
import { AcceptInviteDialog } from "fe2/Components/UIKit/UIKit";
import { promiseWithSpinner } from "helpers/fetch";
import { connect } from "react-redux";

const mapStateToProps = (state, ownProps) => {
  return {
    clanLeveling: ownProps.invite.application_leveling || ownProps.invite.clan.leveling,
    isFetching: state.invites.idsToProcess.includes(ownProps.invite.id)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClick: () => {
    const action = acceptInvite(ownProps.invite);
    const promise = dispatch(action).then(() => dispatch(hideDialog()));
    promiseWithSpinner(dispatch, promise);
  },
  onHideDialog: () => {
    dispatch(hideDialog());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AcceptInviteDialog);